import { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { usePermissions } from "@/hooks/usePermissions";
import { ServiceListings } from "./ServiceListings";

interface ServiceTabProps {
  serviceProviderId?: string | null;
}

const ServiceTab = ({ serviceProviderId }: ServiceTabProps) => {
  const { hasPermission } = usePermissions();
  const navigate = useNavigate();

  const handleOpenCreateService = () => {
    const params = new URLSearchParams();
    if (serviceProviderId) {
      params.append("serviceProviderId", serviceProviderId);
    }
    navigate(`/services/create?${params.toString()}`);
  };

  if (!hasPermission("service_management_read")) {
    return (
      <div className="bg-gray-100 p-6 rounded-lg shadow-lg flex flex-col">
        <div className="text-center py-4 text-gray-500" role="alert">
          You don't have permission to view service management.
        </div>
      </div>
    );
  }

  return (
    <Fragment>
      <ServiceListings
        serviceProviderId={serviceProviderId}
        canCreateService={hasPermission("service_management_create")}
        onCreateService={handleOpenCreateService}
      />
    </Fragment>
  );
};

export { ServiceTab };
